import { FC, SVGProps } from 'react';

const CallAllowIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ size = 20, color = '#fff', ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9771 14.8169C17.2975 19.136 18.5824 13.8349 21.3328 16.5831C23.9856 19.2347 25.5089 19.7648 22.1489 23.1248C21.7279 23.4632 19.0546 27.5337 9.65686 18.1371C0.259124 8.74164 4.32402 6.065 4.66229 5.64387C8.03023 2.27593 8.55238 3.80836 11.2052 6.46002C13.9556 9.21045 8.65681 10.4977 12.9771 14.8169Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8574 7.39126L19.3547 9.89308L24.5003 4.74414"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CallAllowIcon;
